/** @public */ export function isRecord(record) {
    return typeof record === "object" && record !== null && "id" in record && "typeName" in record;
}
export function isDifferent(diff) {
    return Object.keys(diff).length > 0;
}
